import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Checkbox from 'saur_ui_library/src/Atoms/Input/Checkbox/Checkbox';
import Field from 'saur_ui_library/src/Molecules/Field/Field';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import { createGlobalStyle } from 'styled-components';
import { WaterCoursEnvironmentApi } from '../utils/api';
import SingleFilter from '../components/module/component/SingleFilter';
import SaveButton from '../components/common/SaveButton';
import { handleOnSubmit } from '../utils/helpers/apiHelper';
import { loaderDataComponent } from '../utils/helper';

const ReceivingEnvironment = ({
  dataList,
  stations,
  chemicalStations,
  form,
  checkStation,
  setWaterCours,
  setForm,
  code,
  toastError,
  toastSucess,
  stationError,
  setOnLabelChange,
  setDropdownlists,
}) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Card className='receiving-container'>
      <Styles />
      {
        <>
          {form?.label === 'littoral' && (
            <Container className='littoral_error'>
              <Word
                className='note-style'
                variant='span'
                textStyle='normalBold'
                value="Il n'y a pas de milieu associé à l'installation dans un rayon de 25km"
              />
            </Container>
          )}
          <Form
            className='form-style'
            onSubmit={() => {
              if (checkStation) {
                toastError.current?.show(stationError);
              } else {
                handleOnSubmit(
                  setLoading,
                  WaterCoursEnvironmentApi.updateWaterCours(form, code),
                  toastSucess,
                  toastError,
                  setWaterCours
                );
              }
            }}
          >
            <Container className={`${form.coastline && 'grayed-out'}`}>
              <SingleFilter
                module='milieu'
                title='Milieu récepteur '
                filterName='receptor'
                defaultValue={{ name: form?.label || '' }}
                filterOptions={dataList}
                parentCallback={(d) => {
                  setOnLabelChange(true);
                  setForm((oldValues) => {
                    return {
                      ...oldValues,
                      label: d.name !== '' ? d.name : '',
                    };
                  });
                }}
              />
              <SingleFilter
                module='milieu'
                title='Station hydrométrique '
                filterName='stationLabel'
                defaultValue={{
                  name: form.stationLabel || '',
                }}
                filterOptions={
                  stations?.length > 0 ? stations : [{ name: 'Aucune' }]
                }
                parentCallback={(d) => {
                  setForm((oldValues) => {
                    return { ...oldValues, stationLabel: d.name };
                  });
                }}
              />
              <SingleFilter
                module='milieu'
                title='Station physico-chimique '
                filterName='chemicalStationLabel'
                defaultValue={{
                  name: form.chemicalStationLabel || '',
                }}
                filterOptions={
                  chemicalStations?.length > 0
                    ? chemicalStations
                    : [{ name: 'Aucune' }]
                }
                parentCallback={(d) => {
                  setForm((oldValues) => {
                    return {
                      ...oldValues,
                      chemicalStationLabel: d.name,
                    };
                  });
                }}
              />
              {!form?.chemicalStationLabel && chemicalStations?.length <= 0 && (
                <Word
                  className='chemical_error'
                  value="Attention : Aucune station physique-chimique n'est disponible pour cette installation."
                  textStyle='normalItalic'
                  variant='h3'
                  automatedTestId='chemical-error-word'
                />
              )}
            </Container>
            <Container className='checkBox'>
              <Checkbox
                id={1}
                checked={form.coastline}
                onChange={({ value }) => {
                  setForm((oldValues) => {
                    return { ...oldValues, coastline: value };
                  });
                  if (value === true) {
                    setForm((oldValues) => {
                      return {
                        ...oldValues,
                        label: 'littoral',
                        stationLabel: 'littoral',
                        chemicalStationLabel: '',
                      };
                    });
                    setDropdownlists();
                  }
                }}
              />
              <Word
                className='note-style'
                variant='span'
                textStyle='normalReg'
                value='Mon milieu est un littoral'
              />
            </Container>
            <Field
              label='Commentaire'
              className={`${!form.coastline && 'grayed-out'}`}
              value={form.comment || ''}
              placeholder='Votre commentaire'
              errorMessage=''
              onChange={(v) => {
                setForm((oldValues) => {
                  return { ...oldValues, comment: v };
                });
              }}
            />
            {loaderDataComponent(loading, ` width: 28px;
                height: 28px;
                border: 5px solid #FFF;
                border-bottom-color: #243977;
                border-radius: 50%;
                display: inline-block;
                box-sizing: border-box;
                animation: rotation 1s linear infinite;`)}
            {loading === false && <SaveButton />}
          </Form>
        </>
      }
    </Card>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
    .receiving-container{
        display: flex;
        justify-content: center;
        .form-style {
            display: flex;
            flex-direction: column;
            margin: 20px 56px;
            justify-items: center;
            .saveButton{
                display: flex;
                align-items: center;
                margin: 30px;
             }
        }
        .checkBox {
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            span {
                margin-left: 10px;
            }
        }
        .grayed-out {
        opacity: 0.5;
        pointer-events: none;
      }  
    .chemical_error{
      color: red;
      margin-bottom: 2%;
    }
   .littoral_error{
      text-align: center;
      span {
        color: red;
      }
   }
    }
}`;

export default React.memo(ReceivingEnvironment);
